import { PlanningsDeliveryWithLegRunEntity } from 'src/entities/PlanningsDelivery.entity';

/**
 * 配車サマリの総距離 (mm)。
 *
 * operations の走行距離だけでなく、最終納品先から帰着地までの距離
 * (delivery.arrivalDistanceMm) も足す。足していなかったため /plans より小さい値が
 * 出ていた（実測 /map 3,570km ⇔ /plans 4,494km）。
 * 計算式は V3Plans (PlanningTrucks.presenter.tsx:752-760) と同じ。
 *
 * 配車の無い勤務 (operations が空) では帰着距離も足さない。走っていないのに
 * 帰着分だけ積み上がると実態と合わない（V3Plans も haveOperationDeliveryEntities で
 * 絞ってから足している）。
 */
export function sumDistanceMm(
  deliveries: readonly PlanningsDeliveryWithLegRunEntity[],
): number {
  return deliveries.reduce((total, delivery) => {
    const operations = delivery.operations ?? [];
    if (operations.length === 0) return total;

    const driving = operations.reduce((sum, op) => sum + (op.drivingDistanceMm ?? 0), 0);
    return total + driving + (delivery.arrivalDistanceMm ?? 0);
  }, 0);
}
